module.exports = __webpack_public_path__ + "img/IDHAlogga.8d61e8d0.svg";